export interface IContentEventApi {
  usuario?: string; // - "posso colocar o nome e o id seperado por '-'",
  dominio?: string; // - "posso colocar o nome e o id seperado por '-'",
  conteudo?: string; // - "vai ser o payload seja o body ou filtros",
  rota?: string; // - "vai ser o nome da rota chamada para a api do backend separada pelo método (GET - /rota_tal)",
  origem?: string; // - "vai ser a url do navegador",
  resposta_api?: string; // - "sera o número do status",
  navegador?: string; // - "dispositivo acessado pelo usuário e que o navegador conseguiu identificar",
  dispositivo?: string; // - "navegador e versão identificada",
  acessado_em?: string; // - "data de acesso do usuário",
  deslogado_em?: string; // - "data de encerramento de sessão"
}

export interface EventAnalyticsGoogle {
  name: string;
  value: any;
}

export const EVENT_FILTRO_GERENCIAMENTO = 'FILTRO_GERENCIAMENTO_PEDIDOS';
export const EVENT_ACAO_GERENCIAMENTO = 'AÇÕES_GERENCIAMENTO_PEDIDOS';
export const EVENT_PEDIDOS = 'AÇÃO NO MENU DE PEDIDOS';
